const BASE_URL = 'https://ilja-time-tracker.herokuapp.com/api';

const constants = {
  BASE_URL
};

export default constants;
